module.exports = __webpack_public_path__ + "static/media/hospedagens.475bc4ae.svg";